module.exports = __webpack_public_path__ + "static/media/2018_conf_Ten_Things_to_Remember_While_AB_Testing.c2a3ebb6.png";